import { ApiResponse } from "../../apiResponse";
import Axios from "../../axios";

export function availableSession(
  startDate: string | number,
  endDate: number | string,
  learnerToken: number | string
): Promise<ApiResponse> {
  return Axios.get(`/v1/learners/schedule_slots/availability`, {
    params: {
      start_date: startDate,
      end_date: endDate,
      learner_token: learnerToken,
    },
  });
}
